export const tryGetLocalContext = <T>(name: string): T | null => {
  try {
    return inject(name, null)
  } catch {
    return null
  }
}

export default <T>(name: string, generatorOrValue?: T | (() => T)): T => {
  // override the value
  if (typeof generatorOrValue === 'object') {
    provide(name, generatorOrValue)
    return generatorOrValue
  }

  let value: T | null = null
  try {
    value = inject(name, null) || null
  // eslint-disable-next-line no-empty
  } catch {}

  if (value !== null) {
    return value
  }
  if (!generatorOrValue) {
    throw new Error(`Missing local context: "${name}"`)
  }
  const generated = (generatorOrValue as () => T)!()
  provide(name, generated)
  return generated
}
